// El protocolo de la API SIGUE al de la página para evitar "Mixed Content":
// si la web se sirve por HTTPS, la API va por HTTPS; si por HTTP, por HTTP.
const protocol = (typeof window !== 'undefined' && window.location && window.location.protocol === 'https:') ? 'https' : 'http';
const _urls = {
  PROD: {
    contaApi: `${protocol}://${window.location.host}/api/v3`,
    axiosApi: `${protocol}://${window.location.host}/api/v4`,
    nestApi: `${protocol}://${window.location.host}/api/v5`,
    akdeApi: process.env.REACT_APP_API_AKDEMIC || 'https://api.uigv.edu.pe/api/',
  },
  DEV: {
    contaApi: 'http://localhost:8003/',
    axiosApi: 'http://localhost:8004/',
    nestApi: 'http://localhost:8005/',
    akdeApi: 'https://api.uigv.edu.pe/api'
  },
  FRONT: {
    contaApi: `${protocol}://qa-inventarios.contasoft.pe/api/v3`,
    axiosApi: `${protocol}://qa-inventarios.contasoft.pe/api/v4`,
    nestApi: `${protocol}://qa-inventarios.contasoft.pe/api/v5`
  }
}

export const mainUrls = _urls[process.env.REACT_APP_ENVI]

// DEV: {
//   contaApi: `http://localhost:80/api/v3`,
//   axiosApi: `http://localhost:80/api/v4`,
//   nestApi: `http://localhost:80/api/v5`
// }
